import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import SearchPage from "@/pages/SearchPage";
import SagraDetailPage from "@/pages/SagraDetailPage";
import AddSagraPage from "@/pages/AddSagraPage";
import AdminPage from "@/pages/AdminPage";
import NewsPage from "@/pages/NewsPage";
import NewsDetailPage from "@/pages/NewsDetailPage";
import Navbar from "@/components/Navbar";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen bg-background">
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/cerca" element={<SearchPage />} />
<Route path="/sagra/:slug" element={<SagraDetailPage />} />
              <Route path="/aggiungi" element={<AddSagraPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/news/:newsId" element={<NewsDetailPage />} />
            </Routes>
          </main>
          <PWAInstallPrompt />
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;